export default "__VITE_ASSET__owdyOC2u__"